export default __webpack_public_path__ + "static/media/product-08 (1).79469fe2.jpg";